import { goToNextTab } from "@/utils/navigationUtils"

// Helper pour toutes les pages des formulaires.
// expose next() et back()
export default {
  methods: {
    next () {
      goToNextTab(this.$route, this.$router, null)
    },
    back () {
      goToNextTab(this.$route, this.$router, null, true)
    },
  },
}